import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { getFormValues } from 'redux-form';

import { FormName } from '@topconagriculture/feed-types';
import { hideLoader, showLoader } from '@topconagriculture/loader';

import { getDriverPermissions, updateDriverPermissions } from './driverPermissions.actions';
import { compose403ErrorMessage } from '../../../core/helpers/utils/sagaUtils';
import api from '../../../core/api';
import { getUpdatedOperatorPermissionForms } from './driverPermissions.selector';
import { LoadersNames } from '../../ui/ui.constants';

function* getDriverPermissionsSaga() {
  yield put(showLoader(LoadersNames.getDriverPermissions));
  try {
    const result = yield call(api.driverPermissions.getDriverPermissions);
    yield put(
      getDriverPermissions.done({
        result,
      }),
    );
  } catch (err) {
    compose403ErrorMessage(err);
  }
  yield put(hideLoader(LoadersNames.getDriverPermissions));
}

function* updateDriverPermissionsSaga() {
  yield put(showLoader(LoadersNames.updateDriverPermissions));

  try {
    const forms = yield select(getUpdatedOperatorPermissionForms);
    const formValues = yield all(
      forms.map((form) => {
        const values = select(getFormValues(form));
        return values;
      }),
    );

    const payload = formValues?.map(({ full, description, ...rest }) => rest);

    const result = yield call(api.driverPermissions.updateDriverPermissions, payload, FormName.settings);
    yield put(
      updateDriverPermissions.done({
        result,
      }),
    );
  } catch (err) {
    compose403ErrorMessage(err);
  }
  yield put(hideLoader(LoadersNames.updateDriverPermissions));
}

export function* watchDriverPermissionsSaga() {
  yield all([
    yield takeLatest(getDriverPermissions.started, getDriverPermissionsSaga),
    yield takeLatest(updateDriverPermissions.started, updateDriverPermissionsSaga),
  ]);
}
